import React, {
    useState, useContext, useCallback, useEffect
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useValidation } from 'gw-portals-validation-react';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from 'gw-portals-viewmodel-react';
import AdditionalContact from 'gw-capability-fnol-common-react/models/AdditionalContact';
import styles from './SasriaAdditionalContact.module.scss';
// eslint-disable-next-line import/no-unresolved
import metadata from './SasriaAdditionalContact.metadata.json5';


function SasriaAdditionalContact(props) {
    const { id, onValidate, claimVM, updateWizardData } = props;
    const [addContactType, setAdditionalContactType] = useState('');

    const {
        isComponentValid,
        //registerComponentValidation
    } = useValidation(id);
    
   const viewModelService = useContext(ViewModelServiceContext);

    const additionalContactVM = viewModelService.create(
        _.get(claimVM.value, 'additionalContact_EXT') || new AdditionalContact(),
        'cc',
        'edge.capabilities.claim.details.dto.SasriaAdditionalContactDTO_EXT'
    );

    const handleAdditionalContact = useCallback((value) => {
        const isMainContact = value === "mc" ? true : false;
               _.set(additionalContactVM.value,'additionalContactType', isMainContact);
               _.set(claimVM.value, 'additionalContact_EXT', additionalContactVM.value);
               setAdditionalContactType(value)
     },  [claimVM, additionalContactVM, updateWizardData, addContactType]);

    const writeValue = useCallback(
        (value, path) => {
            _.set(additionalContactVM, path, value);
           
            _.set(claimVM.value, 'additionalContact_EXT', additionalContactVM.value);
            
        },
        [claimVM, additionalContactVM]
    );

    const overrideProps = {
        additionalContactTypeId: {
            value: addContactType
        },
        
    };

    const resolvers = {
        resolveClassNameMap: styles,
        
        resolveCallbackMap: {
            handleAdditionalContact: handleAdditionalContact
        } ,
        resolveComponentMap: { 
       }
    };

    const readValue = useCallback(
        (fieldId, path) => {
            return readViewModelValue(
                metadata.componentContent,
                additionalContactVM,
                fieldId,
                path,
                overrideProps
            );
        },
        [additionalContactVM, claimVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={claimVM}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onModelChange={updateWizardData}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            resolveValue={readValue}
            onValueChange={writeValue}
        />
    );
}
SasriaAdditionalContact.propTypes = {
    id: PropTypes.string.isRequired,
   // path: PropTypes.shape({}).isRequired,
    onValidate: PropTypes.func.isRequired,
    updatePath: PropTypes.func.isRequired
};
export default SasriaAdditionalContact;
